<template name="slide">
  <div class="profile">
    <b-row class="no-marg">
      <b-col sm="12" class="column-left" ref="scrollTo">
        <div class="header">
          <Artist
            :id="artist.id"
            :name="artist.name"
            :handle="artist.handle"
            :place="artist.place"
            :requests="artist.requestsCount"
            :showCounter="$root.isMobile"
            :enableInstaLink="true"
            lg
            class="artist"
          ></Artist>
        </div>

        <div id="travels">
          <div class="icon-label">
            <svg svg-inline="" class="icon white" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="47" height="17" viewBox="0 0 47 17"><path fill="#969696" d="M46.066 13.472c.07 1.865-1.397 3.43-3.3 3.498H16.98a.75.75 0 0 1-.63-.344L9.38 5.808a.75.75 0 0 1 .527-1.15l3.142-.438a.75.75 0 0 1 .638.217l5.784 5.885 5-.021-10.066-8.69a.75.75 0 0 1 .44-1.315l4.301-.294a.75.75 0 0 1 .464.122l15.414 10.148 7.533-.05c1.87-.062 3.441 1.39 3.51 3.25zm-3.478-1.75h-.014l-7.768.052a.75.75 0 0 1-.417-.124L18.996 1.515l-2.23.153 10.202 8.806c.525.453.207 1.315-.487 1.318l-7.32.032a.75.75 0 0 1-.538-.225l-5.74-5.84-1.606.223 6.112 9.488h25.35a1.885 1.885 0 0 0 1.828-1.943 1.89 1.89 0 0 0-1.979-1.805zM11.581 15.47a.75.75 0 1 1 0 1.5H.75a.75.75 0 0 1 0-1.5h10.831zm-3.84-3.829c.414 0 .75.224.75.5s-.336.5-.75.5H.75c-.414 0-.75-.224-.75-.5s.336-.5.75-.5h6.991z"/></svg>
            <span class="white">UPCOMING TRAVELS</span>
          </div>
          <Travel
            v-for="(travel, key) in travels"
            :key="key"
            :place="travel.place"
            :studio="travel.studio"
            :start-on="travel.startOn"
            :end-on="travel.endOn"
            class="travel mb-3"
          ></Travel>
          <div v-if="!showTravels" class="no-travels">
            No travels planned at this moment.
          </div>
        </div>
      </b-col>
      <b-col v-if="$root.isDesktop" class="column-separator"></b-col>
      <b-col sm="12" class="column-right">
        <div class="hello">
          <h1>
            “Hello!
            <br v-if="$root.isMobile"/>
            Tell me where
            <br v-if="$root.isMobile"/>
            to travel next.”
          </h1>
          <p class="mb-5 yet-another-grey">
            You'll be notified when I come to your city.
          </p>
        </div>

        <b-row class="no-marg">
          <b-col sm="12" :class="findYourCityClassName">
            <div id="find-your-city">
              <p class="yellow fyc mb-4">REQUEST ME TO YOUR CITY</p>
              <SearchCity @select="selectCity" :enabled="Object.keys(selection).length < 3"/>

              <div v-if="showSelection" class="selection">
                <b-row class="mt-5 mb-4">
                  <b-col cols="7" class="yellow fyc">YOUR SELECTION</b-col>
                  <b-col class="yellow small text-right">3 cities max</b-col>
                </b-row>
                <SelectedCity
                  v-for="(place, placeId) in selection"
                  :key="placeId"
                  :placeId="placeId"
                  :place="place"
                  :count="getCount(placeId)"
                  @remove="removeCity(placeId)"
                />

                <b-button
                  class="big submit"
                  variant="coal-yellow"
                  @click="submit"
                  style="width: 100%;"
                >
                  Request
                </b-button>
              </div>
            </div>
          </b-col>
          <b-col v-if="$root.isDesktop" class="column-sub-separator"></b-col>
          <b-col sm="12" :class="mostRequestedClassName">
            <div>
              <b-row class="most-requested pb-3 no-pad">
                <b-col cols="7" class="white fyc">MOST REQUESTED</b-col>
                <b-col
                  class="small text-right yet-another-grey"
                  v-if="showRequests"
                >
                  tap to select
                </b-col>
              </b-row>
              <div class="bordered requested-cities" v-if="showRequests">
                <RequestedCity
                  v-for="request in requests"
                  :key="request.placeId"
                  :placeId="request.placeId"
                  :place="request.place"
                  :count="request.count"
                  :selected="isSelected(request.placeId)"
                  @select="selectCity({ placeId: request.placeId, place: request.place })"
                />
              </div>
              <p v-else>
                Be the first to request<br/>
                {{ artist.name }}
              </p>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import Artist from '../components/Artist.vue';
import SearchCity from '../components/SearchCity.vue';
import Travel from '../components/Travel.vue';
import RequestedCity from '../components/RequestedCity.vue';
import SelectedCity from '../components/SelectedCity.vue';

export default {
  name: 'ArtistProfile',
  mounted() {
  },
  components: {
    Artist,
    SearchCity,
    Travel,
    RequestedCity,
    SelectedCity,
  },
  data() {
    return {
      travels: {},
      selection: {},
      requests: [],
      loadingArtists: true,
      loadingRequests: true,
    };
  },
  computed: {
    showTravels() {
      return Object.keys(this.travels).length > 0;
    },
    showSelection() {
      return Object.keys(this.selection).length > 0;
    },
    showRequests() {
      return Object.keys(this.requests).length > 0;
    },
    loaded() {
      return !this.loadingArtists && !this.loadingRequests;
    },
    findYourCityClassName() {
      return this.$root.isMobile ? 'order-first' : 'order-last';
    },
    mostRequestedClassName() {
      return this.$root.isMobile ? 'order-last' : 'order-first';
    },
    ...mapGetters(['artist']),
  },
  methods: {
    submit() {
      this.$store.commit('selectedCities', Object.keys(this.selection));
      this.$store.commit('selectedCitiesBkp', this.selection);

      this.$router.push({ name: 'registration' });
    },
    selectCity(city) {
      if (typeof city.place === 'undefined' || typeof city.placeId === 'undefined') {
        return;
      }

      const selection = Object.assign({}, this.selection);

      if (typeof selection[city.placeId] !== 'undefined') {
        delete selection[city.placeId];
      } else {
        if (Object.keys(this.selection).length === 3) {
          return;
        }

        if (Object.keys(selection).length <= 3) {
          selection[city.placeId] = city.place;
        }
      }

      this.selection = selection;

      const places = Object.assign({}, this.$store.getters.places);
      places[city.placeId] = city.place;
      this.$store.commit('places', places);

      window.setTimeout(() => {
        let offset = 0;

        if (this.$root.isMobile) {
          offset = this.$refs.scrollTo.offsetHeight + this.$refs.scrollTo.offsetTop;
          offset += document.getElementsByTagName('header')[0].offsetHeight;
          offset += 40;
        }

        window.scrollTo(0, offset);
      }, 100);
    },
    removeCity(placeId) {
      const selection = {};

      Object.keys(this.selection).forEach((value) => {
        if (value !== placeId) {
          selection[value] = this.selection[value];
        }
      });

      this.selection = selection;
    },
    isSelected(placeId) {
      return typeof this.selection[placeId] !== 'undefined';
    },
    getCount(placeId) {
      const place = this.requests.find(request => request.placeId === placeId);
      return typeof place !== 'undefined' ? place.count : 0;
    },
    ...mapActions(['auth', 'fetchArtist', 'fetchTravels', 'fetchRequests', 'fetchPlaces', 'fetchArtistVariables']),
  },
  created() {
    this.$store.commit('loading', true);
    this.$store.commit('selectedCities', []);

    if (this.$store.getters.fromRegistration) {
      this.selection = Object.assign({}, this.$store.getters.selectedCitiesBkp);
    } else {
      this.$store.commit('selectedCitiesBkp', {});
    }

    this
      .fetchTravels(this.artist.id)
      .then((travelsData) => {
        let travels = [];
        const travelsVal = travelsData.val();

        if (travelsVal) {
          travels = Object.keys(travelsVal).map(key => travelsVal[key]);
          travels = travels.filter(val => val);
          travels = travels.filter(val => val.show);
          travels = travels.filter(val => (new Date(val.endOn)).getTime() > (new Date()).getTime());

          travels.forEach((value, key) => {
            this.$store.dispatch('fillInPlace', travels[key]);
          });

          travels = travels.filter(val => val.place);
          travels = travels
            .sort((a, b) => (new Date(a.startOn)).getTime() - (new Date(b.startOn)).getTime());
        }

        this.travels = travels;
        this.loadingArtists = false;
      });

    this
      .fetchArtistVariables(this.artist.id)
      .then((varResponse) => {
        Object.assign(this.artist, varResponse.val() || this.$store.getters.defaultArtistVar);

        const requests = [];

        Object.keys(this.artist.requests)
          .forEach((key) => {
            if (this.$store.getters.place(key)) {
              requests.push({
                placeId: key,
                place: this.$store.getters.place(key),
                count: this.artist.requests[key],
              });
            }
          });

        this.requests = requests.sort((a, b) => b.count - a.count);
        this.loadingRequests = false;
      });
  },
  beforeDestroy() {
    // Remove google autocomplete elements that don't get destroyed properly
    const elem = document.getElementsByClassName('pac-container')[0];
    elem.parentNode.removeChild(elem);

    this.loadingArtists = true;
    this.loadingRequests = true;
  },
  watch: {
    loaded(isLoaded) {
      if (isLoaded) {
        this.$store.commit('loading', false);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../assets/css/variables';

  .profile {
    padding-top: 20px;
  }

  #travels {
    border-bottom: 1px solid #282828;
    padding-bottom: 20px;
    margin-top: 30px;
    margin-bottom: 35px;

    .icon-label {
      margin-bottom: 24px;
    }
  }

  .bordered {
    border-top: 1px solid #282828;
  }

  .submit {
    margin-top: 8px;
    padding: 22px 56px;
  }

  .yet-another-grey {
    color: #787878;
  }

  .no-travels {
    color: #787878;
    margin-top: -9px;
    padding: 23px 0;
    border-bottom: 1px solid #282828;
  }

  .hello h1 {
    margin-bottom: 12px;
  }

  .mobile {
    .header {
      background-color: $light-black;
      margin: 0 -$side-margin;
      margin-bottom: 40px;
      padding:24px 24px 36px 24px;
    }

    .most-requested {
      margin-top: 40px;
    }

    .no-travels {
      border: 0;
      padding-bottom: 3px;
    }
  }

  .desktop {
    .no-marg {
      margin: 0;
    }

    .artist {
      height: 110px;
      border-bottom: 1px solid #464646;
      margin-bottom: 40px;
    }

    .hello {
      height: 110px;
      border-bottom: 1px solid #464646;
      background-color: #000;
      position: sticky;
      top: 145px;
      z-index: 9999;
    }

    .header {
      background-color: #000;
      position: sticky;
      top: 145px;
      z-index: 9999;
    }

    #travels {
      background-color: #000;
      position: fixed;
      top: 265px;
      z-index: 9999;
      width: 260px;
    }

    #find-your-city {
      background-color: #000;
      position: fixed;
      top: 295px;
      z-index: 9999;
      width: 290px;
    }

    .most-requested {
      background-color: #000;
      position: sticky;
      top: 255px;
      z-index: 9999;
      padding-top: 42px;
    }

    .column-left {
      max-width: 260px;
      padding: 0;
    }

    .column-separator {
      max-width: 90px;
    }

    .column-right {
      max-width: 640px;
      padding: 0;
    }

    .order-first {
      max-width: 290px;
      padding: 0;
    }

    .order-last {
      max-width: 290px;
      padding: 0;
    }

    .column-sub-separator {
      max-width: 60px;
    }

    .bordered {
      border: 0;
    }

    .selection {
      margin-top: 80px;
    }

    #travels {
      border: 0;
    }
  }
</style>
